import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'
import { cn } from '../../lib/cn'

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground shadow hover:bg-primary/90',
        destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        outline: 'border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
        secondary: 'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        sgez: 'bg-sgez-primary text-white shadow-sgez-soft hover:bg-sgez-primary-dark',
        sgezCommit: 'bg-sgez-primary text-white shadow-sgez-soft hover:bg-sgez-primary-dark',
        sgezCreate: 'bg-teal-700 text-white shadow-sm hover:bg-teal-800',
        sgezCreateSoft: 'border border-teal-200 bg-teal-50 text-teal-800 shadow-sm hover:bg-teal-100',
        sgezSelected: 'border border-sgez-primary bg-sky-50 text-sgez-primary shadow-sm ring-1 ring-sgez-primary/10',
        sgezOutline: 'border border-sgez-border bg-white text-sgez-ink shadow-sm hover:bg-sgez-background',
        sgezGhost: 'text-sgez-muted hover:bg-sgez-background hover:text-sgez-ink',
      },
      size: {
        default: 'h-9 px-4 py-2',
        xs: 'h-7 rounded-md px-2.5 text-xs',
        sm: 'h-8 rounded-md px-3 text-xs',
        lg: 'h-10 rounded-md px-8',
        icon: 'h-9 w-9',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button'
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
})
Button.displayName = 'Button'

export { Button, buttonVariants }
